<div id="events-all-none" *ngIf="eventsNone">
</div>
<main [ngClass]="{'active': loading}" cdkScrollable> 
  <div class="loader-animation" *ngIf="loading">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <router-outlet #outlet="outlet"></router-outlet>
</main>